export default __webpack_public_path__ + "static/media/640_business04-it-mobile.929d675c.png";